/* tslint:disable */

/* eslint-disable */
// @ts-nocheck

/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull webui'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 18
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/getclayton/Clayton/implementation/webui)
 */
import * as amplitude from '@amplitude/analytics-browser'

export type Environment = 'production' | 'development'

export const ApiKey: Record<Environment, string> = {
  production: '7a85f244301c99b2f867abfd881c7bab',
  development: '21356bfae7c4c49111892ac98543bded',
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '18',
    branch: 'main',
    source: 'webui',
    versionId: '0b67e2d1-31d2-4d90-8602-7330d4c4281b',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
}

export interface LoadOptionsBase {
  disabled?: boolean
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment
  client?: { configuration?: BrowserOptions }
}
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions }
}
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient }
}

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance

export interface IdentifyProperties {
  /**
   * The current workspace unique identifier
   */
  workspaceId?: string
  /**
   * The workspace name for the current user operating on the UI
   */
  workspaceName: string
  workspaceOnboardingStatus?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ADMIN, COLLABORATOR, USER |
   */
  workspaceRole?: 'ADMIN' | 'COLLABORATOR' | 'USER'
  workspaceStatus?: string
}

export interface ButtonClickedProperties {
  componentId: string
}

export interface ErrorThrownProperties {
  stack?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  status?: number
  swrKey?: string
  message?: string
}

export interface OnboardingTeammatesInvitedProperties {
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
}

export interface OnboardingWidgetViewedProperties {
  workspaceOnboardingStatus: string
}

export interface PageViewedProperties {
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
  /**
   * First segment of the pathname
   */
  pathnameSegment1?: string
  /**
   * Second segment of the pathname
   */
  pathnameSegment2?: string
  /**
   * Third segment of the pathname
   */
  pathnameSegment3?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pathnameSegment4?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pathnameSegment5?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pathnameSegment6?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pathnameSegment7?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pathnameSegment8?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pathnameSegment9?: string
}

export interface PaywallViewedProperties {
  feature: string
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
}

export interface RemediationPlanRuleClickedProperties {
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
  /**
   * This property capture the type of the project
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ENVIRONMENT, GIT |
   */
  projectType?: 'ENVIRONMENT' | 'GIT'
  /**
   * This property is capturing the role of a user within the current project
   */
  projectUserRole?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  rulesCount: number
}

export interface RemediationPlanViewedProperties {
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
  /**
   * This property capture the type of the project
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ENVIRONMENT, GIT |
   */
  projectType?: 'ENVIRONMENT' | 'GIT'
  /**
   * This property is capturing the role of a user within the current project
   */
  projectUserRole?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  rulesCount: number
}

export interface ScanExportClickedProperties {
  /**
   * This property is tracking different file formats used in scan exports.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | CSV, PDF, SARIF, THREADFIX |
   */
  fileFormat: 'CSV' | 'PDF' | 'SARIF' | 'THREADFIX'
  /**
   * This property is capturing the role of a user within the current project
   */
  projectUserRole?: string
}

export interface StatisticCardClickedProperties {
  /**
   * The name of the showed metric
   */
  metricName: string
  /**
   * The value of the showed metric.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  metricValue: number
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
  /**
   * The trend of the statistic.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  trend: number
}

export interface TryFullVersionClickedProperties {
  feature?: string
  /**
   * This property is tracking the pathname of the current page where the event has been triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 0 |
   */
  pathname: string
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY

  constructor(public event_properties: IdentifyProperties) {
    this.event_properties = event_properties
  }
}

export class ButtonClicked implements BaseEvent {
  event_type = 'Button Clicked'

  constructor(public event_properties: ButtonClickedProperties) {
    this.event_properties = event_properties
  }
}

export class ErrorThrown implements BaseEvent {
  event_type = 'Error Thrown'

  constructor(public event_properties?: ErrorThrownProperties) {
    this.event_properties = event_properties
  }
}

export class GitProjectCreationConnectionCompleted implements BaseEvent {
  event_type = 'Git Project Creation Connection Completed'
}

export class GitProjectCreationLicenseCompleted implements BaseEvent {
  event_type = 'Git Project Creation License Completed'
}

export class GitProjectCreationPoliciesCompleted implements BaseEvent {
  event_type = 'Git Project Creation Policies Completed'
}

export class GitProjectCreationRepositoryCompleted implements BaseEvent {
  event_type = 'Git Project Creation Repository Completed'
}

export class GitProjectCreationSubmitted implements BaseEvent {
  event_type = 'Git Project Creation Submitted'
}

export class LeadSourceSubmitted implements BaseEvent {
  event_type = 'Lead Source Submitted'
}

export class LeadSourceWidgetDiscarded implements BaseEvent {
  event_type = 'Lead Source Widget Discarded'
}

export class LeadSourceWidgetViewed implements BaseEvent {
  event_type = 'Lead Source Widget Viewed'
}

export class OnboardingTeammatesInvited implements BaseEvent {
  event_type = 'Onboarding Teammates Invited'

  constructor(public event_properties: OnboardingTeammatesInvitedProperties) {
    this.event_properties = event_properties
  }
}

export class OnboardingWidgetViewed implements BaseEvent {
  event_type = 'Onboarding Widget Viewed'

  constructor(public event_properties: OnboardingWidgetViewedProperties) {
    this.event_properties = event_properties
  }
}

export class PageViewed implements BaseEvent {
  event_type = 'Page Viewed'

  constructor(public event_properties: PageViewedProperties) {
    this.event_properties = event_properties
  }
}

export class PaywallViewed implements BaseEvent {
  event_type = 'Paywall Viewed'

  constructor(public event_properties: PaywallViewedProperties) {
    this.event_properties = event_properties
  }
}

export class RemediationPlanRuleClicked implements BaseEvent {
  event_type = 'Remediation Plan Rule Clicked'

  constructor(public event_properties: RemediationPlanRuleClickedProperties) {
    this.event_properties = event_properties
  }
}

export class RemediationPlanViewed implements BaseEvent {
  event_type = 'Remediation Plan Viewed'

  constructor(public event_properties: RemediationPlanViewedProperties) {
    this.event_properties = event_properties
  }
}

export class SalesforceOrgCreationDetailsCompleted implements BaseEvent {
  event_type = 'Salesforce Org Creation Details Completed'
}

export class SalesforceOrgCreationPoliciesCompleted implements BaseEvent {
  event_type = 'Salesforce Org Creation Policies Completed'
}

export class SalesforceOrgCreationSubmitted implements BaseEvent {
  event_type = 'Salesforce Org Creation Submitted'
}

export class ScanExportClicked implements BaseEvent {
  event_type = 'ScanExport Clicked'

  constructor(public event_properties: ScanExportClickedProperties) {
    this.event_properties = event_properties
  }
}

export class StatisticCardClicked implements BaseEvent {
  event_type = 'Statistic Card Clicked'

  constructor(public event_properties: StatisticCardClickedProperties) {
    this.event_properties = event_properties
  }
}

export class TryFullVersionClicked implements BaseEvent {
  event_type = 'TryFullVersion Clicked'

  constructor(public event_properties: TryFullVersionClickedProperties) {
    this.event_properties = event_properties
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> }

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Button%20Clicked)
   *
   * This event is to track click on specific button.
   *
   * @param properties The event's properties (e.g. componentId)
   * @param options Amplitude event options.
   */
  buttonClicked(
    properties: ButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ButtonClicked(properties), options);
  }

  /**
   * Error Thrown
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Error%20Thrown)
   *
   * This event captures the occurrence of an error being thrown within the WebUI
   *
   * Owner: Davide Ungari
   *
   * @param properties The event's properties (e.g. stack)
   * @param options Amplitude event options.
   */
  errorThrown(
    properties?: ErrorThrownProperties,
    options?: EventOptions,
  ) {
    return this.track(new ErrorThrown(properties), options);
  }

  /**
   * Git Project Creation Connection Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Git%20Project%20Creation%20Connection%20Completed)
   *
   * This event tracks the completion of the connection creation of a new Git repository during the Git project creation process
   *
   * Owner: Davide Ungari
   *
   * @param options Amplitude event options.
   */
  gitProjectCreationConnectionCompleted(
    options?: EventOptions,
  ) {
    return this.track(new GitProjectCreationConnectionCompleted(), options);
  }

  /**
   * Git Project Creation License Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Git%20Project%20Creation%20License%20Completed)
   *
   * This event tracks the completion of the selection of the license during the Git project creation process
   *
   * Owner: Davide Ungari
   *
   * @param options Amplitude event options.
   */
  gitProjectCreationLicenseCompleted(
    options?: EventOptions,
  ) {
    return this.track(new GitProjectCreationLicenseCompleted(), options);
  }

  /**
   * Git Project Creation Policies Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Git%20Project%20Creation%20Policies%20Completed)
   *
   * This event tracks the completion of policies selection
   *
   * during the Git project creation process
   *
   * Owner: Davide Ungari
   *
   * @param options Amplitude event options.
   */
  gitProjectCreationPoliciesCompleted(
    options?: EventOptions,
  ) {
    return this.track(new GitProjectCreationPoliciesCompleted(), options);
  }

  /**
   * Git Project Creation Repository Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Git%20Project%20Creation%20Repository%20Completed)
   *
   * This event tracks the completion of the selection of Git repository during the Git project creation process
   *
   * Owner: Davide Ungari
   *
   * @param options Amplitude event options.
   */
  gitProjectCreationRepositoryCompleted(
    options?: EventOptions,
  ) {
    return this.track(new GitProjectCreationRepositoryCompleted(), options);
  }

  /**
   * Git Project Creation Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Git%20Project%20Creation%20Submitted)
   *
   * This event tracks the submission of a new Git project creation during the Git project creation process
   *
   * Owner: Davide Ungari
   *
   * @param options Amplitude event options.
   */
  gitProjectCreationSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new GitProjectCreationSubmitted(), options);
  }

  /**
   * Lead Source Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Lead%20Source%20Submitted)
   *
   * This event tracks when a lead source is submitted during the onboarding process
   *
   * @param options Amplitude event options.
   */
  leadSourceSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new LeadSourceSubmitted(), options);
  }

  /**
   * Lead Source Widget Discarded
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Lead%20Source%20Widget%20Discarded)
   *
   * This event tracks when a user discards the lead source widget, indicating that they have chosen not to provide information about how they found our website or product
   *
   * @param options Amplitude event options.
   */
  leadSourceWidgetDiscarded(
    options?: EventOptions,
  ) {
    return this.track(new LeadSourceWidgetDiscarded(), options);
  }

  /**
   * Lead Source Widget Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Lead%20Source%20Widget%20Viewed)
   *
   * This event tracks when a user views the lead source widget during the onboarding process
   *
   * @param options Amplitude event options.
   */
  leadSourceWidgetViewed(
    options?: EventOptions,
  ) {
    return this.track(new LeadSourceWidgetViewed(), options);
  }

  /**
   * Onboarding Teammates Invited
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Onboarding%20Teammates%20Invited)
   *
   * This event tracks the invitation of a new team member
   *
   * Owner: Haya Gamal
   *
   * @param properties The event's properties (e.g. pathname)
   * @param options Amplitude event options.
   */
  onboardingTeammatesInvited(
    properties: OnboardingTeammatesInvitedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingTeammatesInvited(properties), options);
  }

  /**
   * Onboarding Widget Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Onboarding%20Widget%20Viewed)
   *
   * This event tracks when a user views the onboarding widget
   *
   * Owner: Davide Ungari
   *
   * @param properties The event's properties (e.g. workspaceOnboardingStatus)
   * @param options Amplitude event options.
   */
  onboardingWidgetViewed(
    properties: OnboardingWidgetViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingWidgetViewed(properties), options);
  }

  /**
   * Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Page%20Viewed)
   *
   * This event tracks when a user views a page while navigating through the WebUI
   *
   * Owner: Davide Ungari
   *
   * @param properties The event's properties (e.g. pathname)
   * @param options Amplitude event options.
   */
  pageViewed(
    properties: PageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageViewed(properties), options);
  }

  /**
   * Paywall Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Paywall%20Viewed)
   *
   * This event tracks when a user views the paywall, which is the screen that prompts them to upgrade from preemium to a paid account.
   *
   * @param properties The event's properties (e.g. feature)
   * @param options Amplitude event options.
   */
  paywallViewed(
    properties: PaywallViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaywallViewed(properties), options);
  }

  /**
   * Remediation Plan Rule Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Remediation%20Plan%20Rule%20Clicked)
   *
   * This event tracks when a user clicks on a remediation plan rule
   *
   * @param properties The event's properties (e.g. pathname)
   * @param options Amplitude event options.
   */
  remediationPlanRuleClicked(
    properties: RemediationPlanRuleClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RemediationPlanRuleClicked(properties), options);
  }

  /**
   * Remediation Plan Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Remediation%20Plan%20Viewed)
   *
   * This event tracks when a user views a remediation plan chart.
   *
   * @param properties The event's properties (e.g. pathname)
   * @param options Amplitude event options.
   */
  remediationPlanViewed(
    properties: RemediationPlanViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RemediationPlanViewed(properties), options);
  }

  /**
   * Salesforce Org Creation Details Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Salesforce%20Org%20Creation%20Details%20Completed)
   *
   * This event tracks the completion of details of the environment project creation process
   *
   * @param options Amplitude event options.
   */
  salesforceOrgCreationDetailsCompleted(
    options?: EventOptions,
  ) {
    return this.track(new SalesforceOrgCreationDetailsCompleted(), options);
  }

  /**
   * Salesforce Org Creation Policies Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Salesforce%20Org%20Creation%20Policies%20Completed)
   *
   * This event tracks the completion of policies selection
   *
   * during the environement project creation process
   *
   * @param options Amplitude event options.
   */
  salesforceOrgCreationPoliciesCompleted(
    options?: EventOptions,
  ) {
    return this.track(new SalesforceOrgCreationPoliciesCompleted(), options);
  }

  /**
   * Salesforce Org Creation Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Salesforce%20Org%20Creation%20Submitted)
   *
   * This event tracks the submission of a new Git project creation during the environment project creation process
   *
   * @param options Amplitude event options.
   */
  salesforceOrgCreationSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new SalesforceOrgCreationSubmitted(), options);
  }

  /**
   * ScanExport Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/ScanExport%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. fileFormat)
   * @param options Amplitude event options.
   */
  scanExportClicked(
    properties: ScanExportClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScanExportClicked(properties), options);
  }

  /**
   * Statistic Card Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/Statistic%20Card%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. metricName)
   * @param options Amplitude event options.
   */
  statisticCardClicked(
    properties: StatisticCardClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new StatisticCardClicked(properties), options);
  }

  /**
   * TryFullVersion Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/getclayton/Clayton/events/main/latest/TryFullVersion%20Clicked)
   *
   * This event tracks when a user clicks on the "Try the full version" button that prompts the user to book a meeting with us.
   *
   * @param properties The event's properties (e.g. feature)
   * @param options Amplitude event options.
   */
  tryFullVersionClicked(
    properties: TryFullVersionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TryFullVersionClicked(properties), options);
  }
}

export const ampli = new Ampli()

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions

export type BrowserClient = amplitude.Types.BrowserClient
export type BaseEvent = amplitude.Types.BaseEvent
export type IdentifyEvent = amplitude.Types.IdentifyEvent
export type GroupEvent = amplitude.Types.GroupIdentifyEvent
export type Event = amplitude.Types.Event
export type EventOptions = amplitude.Types.EventOptions
export type Result = amplitude.Types.Result
